import Vue from 'vue'
import HTTP from '@/http-common.js'

const state = {
  users: {
    active: {},
    pending: {},
  },
  orgs: [],
  user: {},
  org: {},
  api_keys: [],
}

const mutations = {
  setUsers(state, { items, status }) {
    // Loads all users of the logged in user's organisation (admin only)
    state.users[status] = items
  },
  setUser(state, user) {
    // Sets logged-in user's basic info
    state.user = user
  },
  setSingleUser(state, { item, status }) {
    const newItem = JSON.parse(JSON.stringify(item)) // Prevent changing store directly
    const index = state.users[status].findIndex((x) => x.id === newItem.id)
    Vue.set(state.users[status], index, newItem)
  },
  setNewUser(state, item) {
    state.users.active.unshift(item)
  },
  removeSingleUser(state, { id, status }) {
    const index = state.users[status].findIndex((x) => x.id === id)
    state.users[status].splice(index, 1)
  },
  setOrgs(state, orgs) {
    // Loads all organisations (either for registration purposes or admin capabilities)
    state.orgs = orgs
  },
  setOrg(state, org) {
    // Sets logged-in user's organisation, loads accessible website's api_keys
    state.org = org
    if (Object.keys(org).length > 0) state.api_keys = org.websites.map((website) => website.api_key)
  },
  setSingleOrg(state, { item }) {
    // Updates organisation info when editing any organisation from the Organisation menu
    if (item && item.id) {
      const index = state.orgs.findIndex((x) => x.id === item.id)
      Vue.set(state.orgs, index, item)
    } else {
      state.orgs = {}
    }
  },
  removeSingleOrg(state, id) {
    const index = state.orgs.findIndex((x) => x.id === id)
    state.orgs.splice(index, 1)
  },
}

const actions = {
  getUsers({ commit, state }, { status, orgID }) {
    if (!orgID) orgID = state.user.org_id
    return new Promise((resolve, reject) => {
      HTTP.get(`org/${orgID}/members?status=${status}`).then(
        (response) => {
          resolve(commit('setUsers', { items: response.data, status: status }))
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  updateUser({ commit, dispatch }, user) {
    commit('setUser', user)
    if (user.is_admin || user.is_org_admin) dispatch('getUsers', { status: 'pending', orgID: user.org_id })
    if (user.is_admin) dispatch('loadOrgs')
  },
  updateSingleUser({ commit }, { item, status }) {
    commit('setSingleUser', { item, status })
  },
  addNewUser({ commit }, item) {
    commit('setNewUser', item)
  },
  deleteUser({ commit }, id) {
    commit('removeSingleUser', id)
  },
  loadOrgs({ commit }) {
    return new Promise((resolve, reject) => {
      HTTP.get(`list_orgs`).then(
        (response) => {
          resolve(commit('setOrgs', response.data))
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  loadOrg({ commit, state }) {
    return new Promise((resolve, reject) => {
      HTTP.get(`org/${state.user.org_id}`).then(
        (response) => {
          resolve(commit('setOrg', response.data))
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  updateUserOrg({ commit }, org) {
    commit('setOrg', org)
  },
  updateOrg({ commit }, { item }) {
    commit('setSingleOrg', { item })
  },
  deleteOrg({ commit }, id) {
    commit('removeSingleOrg', id)
  },
}

export default {
  state,
  actions,
  mutations,
}
